import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, inject } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AbstractControlComponent } from '../../classes/AbstractControlComponent';
import { FormStatus } from '../../enums/form-status.enum';
import { FormGroupService } from '../../services/form-group.service';

@UntilDestroy()
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-text-area-form-control',
	styleUrls: ['./text-area-form-control.component.scss'],
	templateUrl: './text-area-form-control.component.html',
	viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
	standalone: false,
})
export class TextAreaFormControlComponent extends AbstractControlComponent implements OnInit {
	private changeDetectorRef = inject(ChangeDetectorRef);
	private formGroupDirective = inject(FormGroupDirective);
	private macFormGroupService = inject(FormGroupService);

	FORM_STATUS = FormStatus;

	formControl: FormControl;

	@Input() backgroundColor?: string;
	@Input() controlName: string;
	@Input() disableControl: boolean = undefined;
	@Input() helperText?: string | TemplateRef<any>;
	@Input() label?: string | TemplateRef<any>;
	@Input() placeholder = '';

	ngOnInit(): void {
		this.formControl = this.formGroupDirective.control.get(this.controlName) as FormControl;

		this.macFormGroupService.submit$.pipe(untilDestroyed(this)).subscribe(() => {
			FormGroupService.touchControl(this.formControl);
			this.changeDetectorRef.markForCheck();
		});
	}
}
